import Checkbox from "@/v2-ui/checkbox"
import Icon from "@/v2-ui/icon"
import { RULE_VERSUS_PICKS_LEGEND } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.compose.constants"

/** A checkbox as the legend draws it: the glyph the rows use, not a control. */
function LegendBox(props: { state: boolean | "indeterminate" }) {
  return (
    <Checkbox
      size="sm"
      checked={props.state}
      aria-hidden
      tabIndex={-1}
      className="pointer-events-none mx-0.5 inline-flex align-text-bottom"
    />
  )
}

// The legend every package-lens list carries, in view the whole time: the
// header-versus-single-tick rule, and a key to the three states a row's
// checkbox can be in — because a tick means two different things depending
// on whether the row is package-only, and the box is what everyone reads.
function LicenseFeatureGroupTickLegend() {
  return (
    <>
      {RULE_VERSUS_PICKS_LEGEND} <LegendBox state />{" "}
      <span className="text-foreground">Unlocked here</span>: a package-only row
      (
      <span className="inline-flex size-3.5 items-center justify-center align-text-bottom">
        <Icon src="lock" size={11} />
      </span>
      ) this package carries — only customers whose license or add-on carries it
      get the row. <LegendBox state="indeterminate" />{" "}
      <span className="text-foreground">Placed here</span>: a row that is free
      for every customer today; the dash changes no one&apos;s access, it
      records that this package keeps the row if it is ever made package-only on
      Feature access. <LegendBox state={false} />{" "}
      <span className="text-foreground">Not carried</span> by this package;
      &ldquo;also in …&rdquo; names the packages that carry it. Hover a box for
      the sentence.
    </>
  )
}

export default LicenseFeatureGroupTickLegend
